<template>
   <div class="md-layout md-gutter">
    <div class="md-layout-item">
      <md-field class="_uiKitInput">
        <label for="coloum">{{list.columnFilter.columnName}}</label>
        
        <md-select v-model="selectedColumnItems" name="status" id="status" >
          
          <md-option
                v-for="item in list.columnFilter.columnFilterList"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              >
                {{ item.label }}
                
              </md-option>
              <md-option :key="false" :value="false" class="_filter__reset">
                Reset Filters 
              </md-option>
        </md-select>
     
     
    </md-field>

    </div>
  </div>

</template>

<script>

export default {

  props: {
    list: {
      type: Object,
      required: false,
      default: () => []
    },
    refresh: {
      type: Function,
      required: false
    },
  },

  data() {
    return {
      selectedColumnItems: [],
    };
  },
  mounted() {
    // Sets default status to open in status filter
    if (this.list && this.list.columnFilter && this.list.columnFilter.selectedColumnItems) {
      this.selectedColumnItems = this.list.columnFilter.selectedColumnItems;
    }
  },
  watch: {
    selectedColumnItems: function(event) {
      
      console.log('Select Option',event);
      // Calling refresh method to reload the DynamoList.
      if (this.refresh) {
        this.list.columnFilter.selectedColumnItems = event;
        this.refresh();
      } else {
        this.filterList(event)
      }
    }
  },
  methods: {
    filterList(event) {
       if(!event) {
        if (this.list.columnFilter.sourceData.length > 0) {
          this.list.tableData = this.list.columnFilter.sourceData;
        }
      }
      else {
          if (this.list.columnFilter.sourceData.length == 0) {
            this.list.columnFilter.sourceData = this.list.tableData;
          }
          let result = [];
          
          const itemcasedata = this.list.columnFilter.sourceData.filter(_item => {
            if (_item.status && _item.status.replace(/_/g, " ") == event) {
              return true;
            }
            return false;
          });
          this.list.tableData = itemcasedata;
          console.log('Filter Records', itemcasedata);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
   .md-field {
    max-width: 200px;
    margin-left: 5px;
  }
  ._filter__reset {
    color: rgb(106, 201, 106) !important;
  }
  .md-field-filter::after {
    content: normal;
  }
</style>